<div class="flex flex-col gap-4 w-full h-auto">

    <!-- Cabecera -->
    <div class="flex flex-col items-center gap-2 px-4 text-center text-pet-color-text-2">
        <div class="text-4xl font-black">
            Bienvenido a <span class="ext-pet-color-text-1 ml-1">PET</span><span class="text-red-600">24</span>
        </div>
        <div class="font-normal">
            Desde aca podrás consultar las citas de tus peluditos visualizar el historial de citas y gestionar tu cuenta.
        </div>
    </div>

    <!-- Citas (58%) + Publicidad (42%) -->
    <div class="flex flex-col xl:flex-row gap-5 w-full flex-1 min-h-0">
        <div class="flex flex-col flex-[1.38] min-w-0 min-h-0 gap-3 text-pet-color-text-2 items-center justify-start xl:px-4">
            <div class="text-2xl font-black w-full">
                Tus Próximas Citas
            </div>
            <div class="flex flex-col border border-gray-300 w-full gap-4 px-2 sm:px-4 py-4 rounded-md items-center">
                <app-appointment *ngFor="let item of consultas" [consulta]="item"></app-appointment>
            </div>
        </div>

        <div class="flex min-w-0 items-center justify-center p-2 xl:px-4 xl:flex-1 xl:self-start xl:sticky xl:top-24 xl:h-[min(75vh,900px)]">
            <app-advertisement-carousel class="w-full max-w-[420px] xl:max-w-none"></app-advertisement-carousel>
        </div>
    </div>
</div>